import {
  Definition,
  Node
} from '../types'

import {
  walkNode
} from './nodes.ts'
import {translate} from '../i18n.ts'

interface DocError {
  label: string;
  desc?: string
  nodeId?: string
  nodeName?: string
}
export function getValidationErrors(def: Definition): DocError[] {
  const errors: DocError[] = []
  const uniqueNameMap: Record<string, number> = {}

  function addNodeError(node: Node, errorKey: string) {
    errors.push({
      label: translate(`error.${errorKey}.label`),
      desc: translate(`error.${errorKey}.desc`),
      nodeId: node.id,
      nodeName: node.name
    })
  }

  walkNode(def.trigger, (node, {isFirstChild, isMiddleChild}) => {
    const nameCount = uniqueNameMap[node.name]
    if (nameCount === 1) {
      addNodeError(node, 'duplicateNodeName')
    }
    uniqueNameMap[node.name] = (nameCount || 0) + 1

    if (node.componentType === 'AB_SPLITTER') {
      let sum = 0
      for (const child of node.nextComponents) {
        if (child.componentType === 'AB_SPLITTER_ELEMENT') {
          sum += parseInt(child.percent + '', 10)
        } else {
          addNodeError(node, 'abSplitterInvalidChild')
        }
      }
      if (sum !== 100) {
        addNodeError(node, 'abSplitterNot100')
      }
    } else if (node.componentType === 'ACTION') {
      if (!node.actionType) {
        addNodeError(node, 'actionMissingType')
      }
      if (
        !node.actionId && (
          node.actionType === 'SEND_NOTIFICATION' ||
          node.actionType === 'SEND_TO_ENDPOINT'
        )
      ) {
        addNodeError(node, 'actionInvalid')
      }
    } else if (node.componentType === 'CONNECTOR_ELEMENT') {
      if ((isFirstChild || isMiddleChild) && !node.filters.length) {
        addNodeError(node, 'conditionNoFilters')
      }
      for (const filter of node.filters) {
        if (!filter.value || !filter.operator) {
          addNodeError(node, 'conditionHasInvalidFilter')
        }
      }
    } else if (node.componentType === 'TIMER') {
      if (!node.waitUntilAttribute && !node.waitForSeconds) {
        addNodeError(node, 'timerInvalid')
      }
    }
    
    if (node.nextComponents.length === 0 && node.componentType !== 'ACTION') {
      addNodeError(node, 'leafNodeNotAction')
    }
  })
  return errors
}
